<div>
  <span class="text-md font-heading">{{ 'status.news' | translate }}</span>
  <div class="mt-4 flex max-h-fit flex-col gap-4 overflow-y-auto">
    @for (n of newsItems() | slice: 0 : sliceLength(); track n.id) {
      <pay-login-news-item [newsItem]="n" />
    }
  </div>
</div>
